import { zh, en, ja, zhHant } from '../i18n';
import { getInternationalData, getFeedbackData } from '../service/captcha';

function getFailLang(lang: string) {
  if (/zh-hant/i.test(lang)) {
    return zhHant;
  }
  if (lang.startsWith('zh')) {
    return zh;
  }
  if (lang === 'ja') {
    return ja;
  }
  return en;
}
function getLocalLang(lang: string) {
  if (/zh-hant/i.test(lang)) {
    return zhHant;
  }
  if (lang.startsWith('zh')) {
    return process.env.zhText;
  }
  if (lang === 'ja') {
    return ja;
  }
  if (lang === 'en') {
    return en;
  }
}

export default class SingleText {
  static text: Promise<Obj>;
  static async getText(lang?: string) {
    if (!this.text && lang) {
      if (
        lang.startsWith('zh') ||
        lang.startsWith('en') ||
        lang.startsWith('ja')
      ) {
        // return getFailLang(lang);
        const text = getLocalLang(lang);
        if (text) {
          return text;
        }
      }
      this.text = Promise.all([
        getInternationalData({
          lang: lang,
          tmp: +new Date(),
        }),
        getFeedbackData({
          lang: lang,
        }),
      ])
        .then(([internationalData, feedbackData]) => {
          return {
            ...internationalData.data,
            feedback_text: feedbackData.data,
            voice_text: getFailLang(lang).voice_text,
          };
        })
        .catch((err) => {
          // 兜底处理，中文系的展示中文（zh, zh-Hans，zh-Hant），ja展示日语， 其他展示通用英文
          return getFailLang(lang);
        });
    } else if (!this.text) {
      this.text = Promise.resolve({});
    }
    return this.text;
  }
}
